import { GlobalTaskSearchResult, SelectOption } from "src/types";

export const generateSelectOptions = (
  globalTasks: GlobalTaskSearchResult[],
): SelectOption[] => {
  return globalTasks.map((globalTask) => ({
    backgroundColor: "EDEDEF",
    color: "45485B",
    name: globalTask.title,
    rank: "ab",
    value: globalTask.uuid,
    avatarUrl: globalTask.avatarUrl,
  }));
};
